import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';

export const RichTextSection = styled.section`
  &,
  p {
    font-size: 18px;
    line-height: 1.5;
    color: inherit;
  }

  p {
    margin-bottom: ${layout.spacing.small};
  }

  h1 {
    font-size: 64px;
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: ${layout.spacing.small};

    ${media.smallOnly`
      font-size: 36px;
    `};
  }

  h2 {
    font-size: 48px;
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: ${layout.spacing.small};

    ${media.smallOnly`
      font-size: 28px;
    `};
  }

  h3 {
    font-size: 32px;
    font-weight: 600;
    line-height: 1.3;
    margin-bottom: ${layout.spacing.small};

    ${media.smallOnly`
      font-size: 24px;
    `};
  }

  h4 {
    font-size: 24px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: ${layout.spacing.small};

    ${media.smallOnly`
      font-size: 22px;
    `};
  }

  strong: {
    font-weight: 800;
  }

  ol,
  ul {
    padding-inline-start: ${layout.spacing.medium};

    li {
      padding-left: ${layout.spacing.small};

      &:not(:last-of-type) {
        margin-bottom: ${layout.spacing.small};
      }
    }
  }
`;
